<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.errorLogYouZanList.push"
    :is-show-search-input="true"
    search-placeholder="输入订单号、券码等进行搜索"
  >
    <div
      class="table-filter-item"
      slot="header-item"
    >
      商品未设置签到日期则录入日志
      <el-switch v-model="is_enable" :disabled="isSaving" @change="toggleEnabled"></el-switch>
    </div>

    <v-column-time/>
    <el-table-column label="ID" prop="id"/>
    <v-column-avatar label="提交者"/>
    <el-table-column label="错误类型" width="130px">
      <template v-slot="{ row }">
        <el-tag v-for="apiErrorType in findApiErrorType(row.error_type)" :type="apiErrorType.tagType" :key="`apiErrorType${apiErrorType.value}`">
          {{ apiErrorType.name }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column label="API 返回数据" width="310px">
      <template v-slot="{ row }">
        {{ row.response_body_brief ? `${row.response_body_brief}...` : ''}}
      </template>
    </el-table-column>

    <el-table-column label="系统提示" prop="error_message"/>
    <el-table-column label="有赞订单号" prop="order_number" width="110px"/>
    <el-table-column label="有赞券码" prop="ticket_code"/>
    <el-table-column label="有赞二维码" width="310px">
      <template v-slot="{ row }">
        <div class="ellipsis-2">{{ row.qr_code ? `${row.qr_code}` : ''}}</div>
      </template>
    </el-table-column>

    <el-table-column width="160px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.errorLogYouZanDetail.to(row.id)" icon="browse" name="查看"/>

<!--        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row.id)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此错误日志吗？"
          :is-last="true"
        />-->
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`error-you-zan-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>提交者</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>错误类型</span>
              <div class="list-item-info">
                <el-tag
                  v-for="apiErrorType in findApiErrorType(v.error_type)"
                  :key="`mobile-youzan-error-type-${v.id}-${apiErrorType.value}`"
                  :type="apiErrorType.tagType"
                >
                  {{ apiErrorType.name }}
                </el-tag>
              </div>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">API 返回数据</span>
              <span class="list-item-info">{{ v.response_body_brief ? `${v.response_body_brief}${v.response_body_brief.length > 31 ? '……' : ''}` : '' }}</span>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">系统提示</span>
              <span class="list-item-info">{{ `${v.error_message}${v.error_message && v.error_message.length > 31 ? '……' : ''}` }}</span>
            </div>
            <div class="list-item-detail">
              <span>有赞订单号</span>
              <span>{{ v.order_number }}</span>
            </div>
            <div class="list-item-detail">
              <span>有赞券码</span>
              <span>{{ v.ticket_code }}</span>
            </div>
            <div class="list-item-detail">
              <span>有赞二维码</span>
              <span>{{ v.qr_code ? `${v.qr_code}` : '' }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.errorLogYouZanDetail.to(v.id)" icon="browse" name="查看"/>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { apiErrorTypes, findApiErrorType } from '@/enums/apiErrorTypes';
import { getLegalQueryList } from '@/utils/formats';
import {
  disableYouZanEmptyDateLog,
  enableYouZanEmptyDateLog,
  getYouZanEmptyDateLogIsEnable,
  getYouZanList
} from '@/api/error-log';

export default {
  name: RouteConfig.errorLogYouZanList.name,
  data: () => ({
    RouteConfig,
    apiErrorTypes,
    findApiErrorType,
    isLoading: false,
    isSaving: false,
    isDeleting: {},
    count: 0,
    list: [],
    is_enable: false,
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
      this.getYouZanEmptyDateLogIsEnable();
    },
  },
  beforeMount() {
    this.load();
    this.getYouZanEmptyDateLogIsEnable();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getYouZanList(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async getYouZanEmptyDateLogIsEnable() {
      const { isError, data } = await getYouZanEmptyDateLogIsEnable();
      if (isError) return;

      this.is_enable = !!data.is_enable;
    },
    async enableYouZanEmptyDateLog() {
      const { isError } = await enableYouZanEmptyDateLog();
      if (isError) return;

      this.is_enable = true;
      this.isSaving = false;
    },
    async disableYouZanEmptyDateLog() {
      const { isError } = await disableYouZanEmptyDateLog();
      if (isError) return;

      this.is_enable = false;
      this.isSaving = false;
    },
    toggleEnabled(is_enable) {
      if (this.isSaving) return;

      this.isSaving = true;
      is_enable ? this.enableYouZanEmptyDateLog() : this.disableYouZanEmptyDateLog();
    },
  },
};
</script>
